import React from 'react';
import { connect } from 'react-redux';

import logoCapitaliza from '../../img/logo_capitaliza.png';
import logoEquantia from '../../img/logo_equantia.jpg';
import './style.css';

class EquantiaGroup extends React.Component {
  render() {
    const { language } = this.props;

    const languageContent = require(`../../langs/${language}`).default
      .equantiaGroup;

    return (
      <div className='equantia-group__wrapper'>
        <h1>GRUPO EQUANTIA</h1>
        <div className='equantia-info__wrapper'>
          <img src={logoEquantia} alt='Logo equantia' />
          {languageContent.equantiaParagraph}
        </div>
        <div className='capitaliza-info__wrapper'>
          <img src={logoCapitaliza} alt='Logo capitaliza' />
          {languageContent.capitalizaParagraph}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    language: state.language.lang
  };
};

export default connect(
  mapStateToProps,
  null
)(EquantiaGroup);
